import React from "react";
import EventForm from "..";

function CreateEvent() {
  return <EventForm mode="create" />;
}

export default CreateEvent;
